The images for the Apply with SEEK button, with different background colours.
